import logo from './logo.svg';
import './App.css';
import QRCode from "react-qr-code";
import { useSearchParams } from 'react-router-dom';
import { Route } from 'react-router-dom';
import { Router } from 'react-router-dom';
import { BrowserRouter } from 'react-router-dom';
import { Routes } from 'react-router-dom';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import React, { useState, useEffect } from 'react'
import { Button } from '@mui/material';
import { TextField } from '@mui/material';
import { Link } from 'react-router-dom';

const Home = () => {
  const [trackingNumber, setTrackingNumber] = useState("");

  const [searchParams, setSearchParams] = useSearchParams();
  let emailAddress = searchParams.get("emailaddress")
  if(emailAddress) {
    emailAddress = emailAddress.toLocaleLowerCase();
  }

  var validEmailAddresses = ["store3590@theupsstore.com", "store4920@theupsstore.com"];

  if(!validEmailAddresses.includes(emailAddress)){
    emailAddress = "store5284@theupsstore.com"
  }

  let counter = 0;

  function onClose() {
    console.log(counter)
    if (counter == 1) {
      console.log("here 1")
      // window.close()
      counter = 0
    }
    else {
      console.log("here 0")

      counter = counter + 1
    }

  }

  useEffect(() => {
    if (emailAddress) {
      //copyToClipboard()
    }
  }, [emailAddress]);

  function copyToClipboard() {
    navigator.clipboard.writeText(emailAddress)

   
    toast(`${emailAddress} has been copied to your clipboard. You can paste it in any program`, {
      position: "bottom-center",
      autoClose: 500000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "light",
      // onClose: () => onClose()
    })
  }

  return (
    <div style={{textAlign:"center"}}>
      {/* <h2>
      Our Email Address is

      </h2>
      <br />
      <h1 style={{wordWrap:"break-word"}}>
      {emailAddress}
      </h1>
      <br />

      <Button variant="contained"  onClick={() => { copyToClipboard() }}>Tap Here To <br />Copy Email Address <br /> & <br />used it in any Program</Button>


      <ToastContainer /> */}


      {/* <QRCode value={emailAddress} /> */}

      <TextField placeholder='Tracking Number' value={trackingNumber} onChange={(e)=>{setTrackingNumber(e.target.value)}}></TextField>
      <br></br>


<Button href={'https://iship.com/trackit/track.aspx?t=1&Track=' + trackingNumber + '&src=_e' } target={"_blank"} variant="contained">
  Track Package
</Button>

    </div>
  )
}
function App() {



  return (
    <React.StrictMode enabled={false}>

      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />}>

          </Route>
        </Routes>
      </BrowserRouter>   </React.StrictMode>

  );
}

export default App;
